<script lang="ts">
  import { closeModal } from "@thehood/svlib";
  import type { IFilterOption } from "../_helper/product-manager";
  export let onConfirm: (args: IFilterOption) => void;
  export let onClose: () => void;
  export let availableCategories: Map<string, { title: string; colour: string }>;
  // export let availableCategories: [string, { title: string; colour: string }][] | undefined = [];

  function applyFilter() {
    const category = [...selectedcategories];
    const filterArgs: IFilterOption = { category };
    onConfirm(filterArgs);
    closeModal();
  }

  let selectedcategories = new Set<string>();
  let myObject: Record<string, boolean> = {};

  function close() {
    closeModal();
    onClose();
  }

  function selectCategories(value: string) {
    if (myObject[value]) {
      myObject[value] = false;
      selectedcategories.delete(value);
    } else {
      myObject[value] = true;
      selectedcategories.add(value);
    }
  }
</script>

<section class="filter">
  <div>
    <i />
    <h2 class="pf-400">Filter by locations</h2>
    <button on:click={close}>X</button>
  </div>
  <ul>
    {#each Array.from(availableCategories) as [value, item]}
      <li class="pf-400" class:active={myObject[value]}>
        <button on:click={() => selectCategories(value)} class:active={myObject[value]}>
          <i class:active={myObject[value]} style={`background-color:${item.colour}`} /><span>{item.title}</span>
        </button>
      </li>
    {/each}
  </ul>
  <button on:click={applyFilter}>Filter</button>
</section>

<style lang="scss">
  @use "@styles/breakpoint-mixins" as *;
  .filter {
    z-index: var(--z2);
    position: fixed;
    top: 10%;
    right: 10%;
    left: 5%;
    bottom: unset;
    border-radius: 10px;
    border: 1px solid #d8d8d8;
    background: #fff;
    padding: 1.5em 1em;
    display: grid;
    grid-template-columns: 1fr;
    gap: 1em;
    @include tablet {
      max-width: 30em;
      bottom: unset;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    div {
      display: grid;
      align-items: center;
      grid-template-columns: 2em 1fr 2em;
      gap: 0.5em;
      i {
        display: block;
        width: 2em;
        height: 0.8em;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url("../_assets/circles.svg");
      }
      h2 {
        margin: 0;
        font-size: 1.1em;
      }
      button {
        width: 1.5em;
        height: 1.5em;
        padding: 1px 0 0 0;
        border: none;
        background: #b7b7bc;
        border-radius: 50%;
        i {
          width: 2em;
          height: 2em;
        }
      }
    }
    ul {
      margin: 0;
      li {
        border-radius: 2em;
        list-style: none;
        transition: background-color 0.2s ease-in-out;
        button {
          display: grid;
          align-items: center;
          grid-template-columns: 1em auto;
          gap: 0.5em;
          padding: 0.5em 0 0.5em 1em;
          background: none;
          border: none;
          color: #000;
          text-align: left;
          i {
            display: block;
            width: 1em;
            height: 1em;
            border-radius: 50%;
            border: 1px solid #f8f8f8;
            opacity: 0.2;
          }
        }

        .active {
          background: #f2f2f2;
          i {
            opacity: 0.8;
          }
        }
      }

      li:hover {
        background: #f2f2f2;
      }
    }
  }
</style>
